'use client';
import { motion } from 'framer-motion';
import { profile } from '@/data/profile';
import OrbitalObject from '../ui/OrbitalObject';
import TechIcon from '../ui/TechIcon';

export default function Skills() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  // Create 20 orbital objects with varying properties
  const orbitalConfigs = Array.from({ length: 20 }, (_, index) => ({
    color: [
      "#4f83ff", "#83ff4f", "#ff4f83", "#ff834f", "#834fff",
      "#4fff83", "#ff4fff", "#ffff4f", "#4fffff", "#ffffff",
      "#ff6b6b", "#4ecdc4", "#45b7d1", "#96ceb4", "#feca57",
      "#ff9ff3", "#54a0ff", "#5f27cd", "#00d2d3", "#ff9f43"
    ][index % 20],
    size: 4 + (index % 8) + 2, // Sizes from 6 to 13
    orbitDuration: 15 + (index % 25) + 5, // Duration from 20 to 44 seconds
    orbitRadius: 80 + (index % 15) * 20, // Radius from 80 to 360
    delay: (index % 10) * 2, // Delays from 0 to 18 seconds
  }));

  return (
    <section id="skills" className="py-20 bg-black relative overflow-hidden">
      {/* Map through 20 orbital objects */}
      {orbitalConfigs.map((config, index) => (
        <div key={index} className="absolute inset-0" style={{ left: '50%', top: '50%' }}>
          <OrbitalObject
            color={config.color}
            size={config.size}
            orbitDuration={config.orbitDuration}
            orbitRadius={config.orbitRadius}
            delay={config.delay}
          />
        </div>
      ))}

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-3xl font-bold mb-12 text-center text-white">Skills & Expertise</h2>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {profile.skills.map((skillCategory, index) => (
            <motion.div
              key={index}
              variants={item}
              className="bg-zinc-800/80 backdrop-blur-sm p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border border-zinc-700 relative group"
              whileHover={{ scale: 1.02 }}
            >
              <h3 className="text-xl font-semibold mb-4 text-white">{skillCategory.category}</h3>
              <div className="flex flex-wrap gap-3">
                {skillCategory.items.map((skill, skillIndex) => (
                  <motion.div
                    key={skillIndex}
                    whileHover={{ scale: 1.1 }}
                    className="transform transition-transform duration-200"
                  >
                    <TechIcon tech={skill} className="skills-icon" />
                  </motion.div>
                ))}
              </div>
              <div className="absolute inset-0 bg-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}